/* ----------------------------------------------------------------------------
 * TRX "Patient Data Collection" visit form — Visit 2+ (Follow-up) Chapters
 *
 * Mapped to the V2 components extracted from the production bundle:
 *   AnthropometricsSharedV2, VitalSignsSharedV2, EatingDrinkingSharedV2,
 *   SmokingHistorySharedV2, MorbiditiesSharedV2, MedicationSharedV2,
 *   TrxSpecificsV2, LaboratoryV2, CopdTrxV2, LungFunctionV2,
 *   BreathAnalysisSharedV2, Visit2FinishShared.
 * ------------------------------------------------------------------------- */
import { vitalSigns } from './bro'
import { eatingDrinking } from './bex'
import { breathAnalysis } from './bex'
import {
  anthropometricsV2,
  smokingV2,
  morbiditiesV2,
  medicationV2,
} from './bro.v2'

export const trxSpecificsV2 = [
  {
    type: 'select',
    name: 'quitQuestionnaire',
    label: 'QUIT questionnaire',
    options: { '': '', adherent: 'adherent', nonAdherent: 'non-adherent' },
  },
]

export const laboratoryV2 = [
  {
    type: 'group',
    name: 'laboratory',
    children: [
      { type: 'text', name: 'crp', label: 'CRP (mg/l)' },
      { type: 'date', name: 'crpDate', label: 'Date' },
      { type: 'text', name: 'eosinophils', label: 'Eosinophils (G/l)' },
      { type: 'date', name: 'eosinophilsDate', label: 'Date' },
    ],
  },
]

export const copdQuestionnairesV2 = [
  { type: 'text', name: 'CATScore', label: 'CAT score' },
  { type: 'text', name: 'mMRCscore', label: 'mMRC score' },
]

export const lungFunctionV2 = [
  {
    type: 'group',
    name: 'spirometry',
    children: [
      { type: 'date', name: 'date', label: 'Date of spirometry' },
      { type: 'text', name: 'FEV1-L', label: 'FEV1 (l)' },
      { type: 'text', name: 'FEV1-percent', label: 'FEV1 (%)' },
      { type: 'text', name: 'FVC-L', label: 'FVC (l)' },
      { type: 'text', name: 'FVC-percent', label: 'FVC (%)' },
      { type: 'text', name: 'FEVtoFVC', label: 'FEV1/FVC (%)' },
      { type: 'text', name: 'PEF', label: 'Peak Expiratory Flow (PEF) (l/s)' },
      { type: 'text', name: 'TLC-L', label: 'Total Lung Capacity (TLC) (l)' },
      {
        type: 'text',
        name: 'TLC-percent',
        label: 'Total Lung Capacity (TLC) (%)',
      },
      { type: 'text', name: 'RV-L', label: 'Residual Volume (RV) (l)' },
      { type: 'text', name: 'RV-percent', label: 'Residual Volume (RV) (%)' },
      { type: 'text', name: 'TLCtoRV', label: 'TLC/RV (%)' },
      { type: 'text', name: 'DLCO', label: 'DLCO (mmol/kPa/min)' },
      { type: 'text', name: 'DLCO-percent', label: 'DLCO (%)' },
      { type: 'text', name: 'FenO', label: 'FeNO (ppb)' },
    ],
  },
]

const finish = [{ component: 'h4', children: 'Visit 2 Completion' }]

export default {
  chapters: [
    {
      key: 'anthropometrics',
      name: 'Anthropometrics',
      schema: anthropometricsV2,
    },
    { key: 'vitalSigns', name: 'Vital signs', schema: vitalSigns },
    {
      key: 'eatingDrinking',
      name: 'Eating & drinking habits',
      schema: eatingDrinking,
    },
    { key: 'smokingHistory', name: 'Smoking history', schema: smokingV2 },
    { key: 'morbidities', name: 'Morbidities', schema: morbiditiesV2 },
    { key: 'medication', name: 'Medication', schema: medicationV2 },
    {
      key: 'trxSpecifics',
      name: 'TripleEx specifics (QUIT)',
      schema: trxSpecificsV2,
    },
    { key: 'laboratory', name: 'Laboratory', schema: laboratoryV2 },
    {
      key: 'copdQuestionnaires',
      name: 'COPD Specific Questionnaires',
      schema: copdQuestionnairesV2,
    },
    { key: 'lungFunction', name: 'Lung Function', schema: lungFunctionV2 },
    { key: 'breathAnalysis', name: 'Breath analysis', schema: breathAnalysis },
    { key: 'finish', name: 'Visit completion', schema: finish },
  ],
}
